import axios from '@/plugins/axios';

// 生成并发放优惠券
export function saveCoupon(params) {
  return axios.post('/sysCoupon/saveCoupon', params);
}
// 优惠券列表
export function getCouponList(params) {
  return axios.post('/sysCoupon/couponList', params);
}
// 禁用启用优惠券
export function changeCouponStatus(couponIds, status) {
  return axios.post('/sysCoupon/updateCouponStatus', {
    couponIds: couponIds,
    status: status
  });
}
